



































import Vue from 'vue'

export default Vue.extend({
  name: 'SectionTitle',
  props: {
    label: {
      type: String,
      default: ''
    },
    icon: {
      default: null
    },
    onClickIcon: {
      type: Function,
      default: () => {}
    }
  }
})
